import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm11 7.938V4.062a8.001 8.001 0 0 1 0 15.876ZM4.062 13A8.004 8.004 0 0 0 11 19.938V13H4.062Zm0-2H11V4.062A8.004 8.004 0 0 0 4.062 11Z"
    />
  </svg>
);
export default IconDrillingPartLeftStrokedSizeM;
